<script setup lang="ts">
defineProps<{
  /** Sparkle tier: 1 (low), 2 (medium), 3 (high) */
  tier: number
  /** SVG center X coordinate */
  cx: number
  /** SVG center Y coordinate */
  cy: number
}>()
</script>

<template>
  <g class="sparkle-indicator">
    <!-- Tier 1: single small sparkle -->
    <template v-if="tier >= 1">
      <circle
        :cx="cx + 12"
        :cy="cy - 8"
        r="2"
        fill="#F5E5AA"
        opacity="0.9"
      >
        <animate
          attributeName="opacity"
          values="0.4;1;0.4"
          dur="3s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="r"
          values="1.5;2.5;1.5"
          dur="3s"
          repeatCount="indefinite"
        />
      </circle>
    </template>

    <!-- Tier 2: two sparkles, slightly faster -->
    <template v-if="tier >= 2">
      <circle
        :cx="cx - 10"
        :cy="cy - 10"
        r="2"
        fill="#F5E5AA"
        opacity="0.8"
      >
        <animate
          attributeName="opacity"
          values="0.3;1;0.3"
          dur="2.4s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="r"
          values="1.5;3;1.5"
          dur="2.4s"
          repeatCount="indefinite"
        />
      </circle>
    </template>

    <!-- Tier 3: third sparkle + outer glow ring -->
    <template v-if="tier >= 3">
      <circle
        :cx="cx + 6"
        :cy="cy + 12"
        r="2"
        fill="#FFFFFF"
        opacity="0.7"
      >
        <animate
          attributeName="opacity"
          values="0.2;0.9;0.2"
          dur="2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="r"
          values="1;3;1"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
      <!-- Outer glow -->
      <circle
        :cx="cx"
        :cy="cy"
        r="14"
        fill="none"
        stroke="#F5E5AA"
        stroke-width="0.8"
        opacity="0.3"
      >
        <animate
          attributeName="opacity"
          values="0.1;0.4;0.1"
          dur="4s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="r"
          values="12;16;12"
          dur="4s"
          repeatCount="indefinite"
        />
      </circle>
    </template>
  </g>
</template>
